import React, { useEffect } from 'react';
import sdk from '@farcaster/miniapp-sdk';

/**
 * MiniAppWrapper - Detects and adapts interface for Base Mini App environment
 */
export default function MiniAppWrapper({ children }) {
  useEffect(() => {
    // Detect mobile device with multiple methods
    const isMobileUserAgent = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    const isMobileWidth = window.innerWidth <= 768;
    const isTouchDevice = 'ontouchstart' in window || navigator.maxTouchPoints > 0;
    const isTabletWidth = window.innerWidth <= 1024; // Include tablets
    
    const isMobileDevice = isMobileUserAgent || isMobileWidth || (isTouchDevice && isTabletWidth);
    
    // Detect if running inside Base Mini App OR on mobile device
    const isMiniApp = window?.parent !== window || 
                      navigator.userAgent.includes('MiniApp') ||
                      window.location.search.includes('miniapp=true') ||
                      isMobileDevice;
    
    if (isMiniApp) {
      // Add mini app specific styling
      document.body.classList.add('miniapp-mode');
      
      // Adjust viewport for mobile optimization
      const viewport = document.querySelector('meta[name="viewport"]');
      if (viewport) {
        viewport.setAttribute('content', 
          'width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no, viewport-fit=cover'
        );
      }
      
      // Add Base Mini App specific meta tags
      if (!document.querySelector('meta[name="theme-color"]')) {
        const themeColor = document.createElement('meta');
        themeColor.name = 'theme-color';
        themeColor.content = '#0052ff';
        document.head.appendChild(themeColor);
      }
      
      // Log miniapp activation (production ready)
      if (window?.parent !== window || navigator.userAgent.includes('MiniApp') || window.location.search.includes('miniapp=true')) {
        console.log('🎯 GuiltBox running in Base Mini App mode');
      } else {
        console.log('📱 GuiltBox auto-enabled miniapp mode for mobile device');
      }
      
      // Signal that the mini app is ready
      sdk.actions.ready();
    }
    
    return () => {
      document.body.classList.remove('miniapp-mode');
    };
  }, []);

  return <>{children}</>;
}